import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import map from 'lodash/fp/map';
import isPlainObject from 'lodash/fp/isPlainObject';
import isObjectLike from 'lodash/fp/isObjectLike';
import isArray from 'lodash/fp/isArray';
import set from 'lodash/set';
import transform from 'lodash/transform';
import omit from 'lodash/omit';
import snakeCase from 'lodash/snakeCase';
import axios from 'axios';
import identity from 'lodash/identity';
import isArray$1 from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isNaN$1 from 'lodash/isNaN';
import map$1 from 'lodash/map';
import omitBy from 'lodash/omitBy';
import kebabCase from 'lodash/kebabCase';
import compact from 'lodash/compact';
import get from 'lodash/get';
import toUpper from 'lodash/toUpper';
import camelCase from 'lodash/camelCase';
import forEach from 'lodash/forEach';
import find from 'lodash/find';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = unwrapExports(defineProperty);

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = unwrapExports(slicedToArray);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

var createHumps_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createHumps;

var _map2 = _interopRequireDefault(map);

var _isPlainObject2 = _interopRequireDefault(isPlainObject);

var _isObjectLike2 = _interopRequireDefault(isObjectLike);

var _isArray2 = _interopRequireDefault(isArray);

var _set2 = _interopRequireDefault(set);

var _transform2 = _interopRequireDefault(transform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createIteratee(converter, self) {
  return function (result, value, key) {
    return (0, _set2["default"])(result, converter(key), (0, _isObjectLike2["default"])(value) ? self(value) : value);
  };
}

function createHumps(keyConverter) {
  return function humps(node) {
    if ((0, _isArray2["default"])(node)) return (0, _map2["default"])(humps, node);
    if ((0, _isPlainObject2["default"])(node)) return (0, _transform2["default"])(node, createIteratee(keyConverter, humps));
    return node;
  };
}

module.exports = exports.default;
});

var createHumps = unwrapExports(createHumps_1);

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

var buildApi = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_ref) {
    var headers, baseUrl, requestTimeout, credentials, customHeaders;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = _ref.headers, baseUrl = _ref.baseUrl, requestTimeout = _ref.requestTimeout, credentials = _ref.credentials;
            _context.next = 3;
            return typeof headers === 'function' ? headers(defaultHeaders) : headers;

          case 3:
            customHeaders = _context.sent;
            return _context.abrupt("return", axios.create({
              baseURL: baseUrl,
              timeout: requestTimeout,
              withCredentials: Boolean(credentials),
              auth: credentials,
              headers: _objectSpread$9(_objectSpread$9({}, defaultHeaders), customHeaders)
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function buildApi(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var buildQueryString = function buildQueryString(query, options) {
  if (isEmpty(query)) return null;
  var parser = (options === null || options === void 0 ? void 0 : options.queryStringParser) || identity;
  var filteredQuery = omitBy(query, function (val) {
    return isNaN$1(val) || isNil(val);
  });
  var queryString = map$1(filteredQuery, function (value, key) {
    return isArray$1(value) ? map$1(value, function (v) {
      return "".concat(parser(key), "[]=").concat(v);
    }).join('&') : "".concat(parser(key), "=").concat(value);
  });
  return queryString.join('&');
};

var joinWith = function joinWith(separator) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return compact(args).join(separator);
};

var defaultUrlParser = kebabCase;

var buildUrl = function buildUrl(_ref) {
  var name = _ref.name,
      urlParser = _ref.urlParser,
      path = _ref.path,
      customPath = _ref.customPath;
  return function (id) {
    if (!name) return '/';
    var defaultPath = (urlParser || defaultUrlParser)(name);
    var pathWithId = joinWith('/', path || defaultPath, id);
    var builtPath = customPath || pathWithId;
    var parsedPath = id ? builtPath.replace(/(ˆ|\/)+(:id)+($|\/)/g, "/".concat(id, "/")) // replace ":id" with passed id
    : builtPath;
    return parsedPath.replace(/([^https?:]\/)\/+/g, '$1'); // remove extra "//" on urls
  };
};

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var consoleGroup = function consoleGroup(title, color) {
  return function () {
    console.group("%c".concat(title), "color: ".concat(color, ";"));

    for (var _len = arguments.length, log = new Array(_len), _key = 0; _key < _len; _key++) {
      log[_key] = arguments[_key];
    }

    log.map(function (info) {
      return console.log(info);
    });
    console.groupEnd();
  };
};

var responseLogger = function responseLogger(url, method, response) {
  consoleGroup('RESPONSE: ', 'coral')("".concat(method.toUpperCase(), ": ").concat(url), response === null || response === void 0 ? void 0 : response.data);
};

var requestLogger = function requestLogger(url, method, params) {
  consoleGroup('REQUEST: ', 'mediumpurple').apply(void 0, _toConsumableArray(compact(["".concat(toUpper(method), ": ").concat(url), params])));
};

var defaultParseErrors = function defaultParseErrors(error) {
  if (error.response) {
    return get(error.response, 'data.message') || get(error.response, 'data.errors.0') || get(error.response, 'data.errors.full_messages.0') || get(error.response, 'data.error') || joinWith(' - ', get(error.response, 'status'), get(error.response, 'statusText'));
  }

  if (get(error.request, 'responseText') || get(error.request, 'status')) {
    return get(error.request, 'responseText') || joinWith(' - ', error.request.status, error.request.statusText);
  } // Something happened in setting up the request that triggered an Error


  return error.message || 'Unknown error';
};

var doFail = function doFail(path, method, _ref) {
  var after4xx = _ref.after4xx,
      after5xx = _ref.after5xx,
      afterFailure = _ref.afterFailure,
      afterResponse = _ref.afterResponse,
      debugRequests = _ref.debugRequests,
      handleResponseHeaders = _ref.handleResponseHeaders,
      parseErrors = _ref.parseErrors;
  return function (error) {
    debugRequests && responseLogger(path, method, error.response);

    if (error.response && error.response.status) {
      var _error$response = error.response,
          status = _error$response.status,
          statusText = _error$response.statusText,
          data = _error$response.data;
      var is4xx = status >= 400 && status < 500;
      var is5xx = status >= 500 && status < 600;
      is4xx && after4xx && after4xx(status, statusText, data);
      is5xx && after5xx && after5xx(status, statusText, data);
    }

    error.response && handleResponseHeaders && handleResponseHeaders(error.response);
    afterFailure && afterFailure(error);
    error.response && afterResponse && afterResponse(error.response);
    var parsedError = defaultParseErrors(error);
    return parseErrors ? parseErrors(error, parsedError) : parsedError;
  };
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultParamsUnparser = camelCase;

var defaultParseResponse = function defaultParseResponse(_ref) {
  var data = _ref.data;
  return data;
};

var getParser = function getParser(word, config) {
  return get(config, "parse".concat(word, "Response"));
};

var doSuccess = function doSuccess(path, method, _ref2, id) {
  var debugRequests = _ref2.debugRequests,
      afterSuccess = _ref2.afterSuccess,
      afterResponse = _ref2.afterResponse,
      handleResponseHeaders = _ref2.handleResponseHeaders,
      paramsUnparser = _ref2.paramsUnparser,
      parseResponse = _ref2.parseResponse,
      config = _objectWithoutProperties(_ref2, ["debugRequests", "afterSuccess", "afterResponse", "handleResponseHeaders", "paramsUnparser", "parseResponse"]);

  return function (response) {
    var parsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var parser = (id ? getParser(parsers[0], config) : getParser(parsers[1], config)) || getParser(parsers[2], config) || parseResponse || defaultParseResponse || identity;
    debugRequests && responseLogger(path, method, response);
    var unparseParams = createHumps(paramsUnparser || defaultParamsUnparser);

    var unparsedResponse = _objectSpread$8(_objectSpread$8({}, response), {}, {
      data: unparseParams(response.data)
    });

    handleResponseHeaders && handleResponseHeaders(unparsedResponse);
    afterSuccess && afterSuccess(unparsedResponse);
    afterResponse && afterResponse(unparsedResponse);
    return parser(unparsedResponse);
  };
};

var initialState = {
  info: null,
  list: [],
  fetchingInfo: false,
  fetchingList: false,
  saving: false,
  destroying: false,
  infoError: null,
  listError: null,
  saveError: null,
  destroyError: null
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getStateKey(name, stateId) {
  return joinWith('@', name, stateId);
}

function findStatePiece(state, name, stateId, initializeFetching, id) {
  var path = getStateKey(name, stateId);
  var piece = get(state, path);
  return piece || _objectSpread$7(_objectSpread$7({}, initialState), {}, {
    fetchingInfo: Boolean(initializeFetching && id),
    fetchingList: Boolean(initializeFetching && !id)
  });
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var shouldUseCache = function shouldUseCache(_ref) {
  var cache = _ref.cache,
      options = _objectWithoutProperties(_ref, ["cache"]);

  return function (id, piece, setInfo) {
    if (!id && piece.list && !!piece.list.length && cache) return true;
    var hasInfo = id && piece.list && piece.list.length && setInfo(_objectSpread$6(_objectSpread$6({}, options), {}, {
      id: id
    }));
    return !!(hasInfo && cache);
  };
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function emitChanges(store, updateContext) {
  var emitToAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  store.listeners && store.listeners.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        context = _ref2[0],
        listener = _ref2[1];

    if (updateContext === context || emitToAll) {
      listener(store.state);
    }
  });
}

function setState(newState, updateContext) {
  this.state = _objectSpread$5(_objectSpread$5({}, this.state), newState);
  emitChanges(this, updateContext);
}

function clearState() {
  this.state = {};
  emitChanges(this, undefined, true);
}

function useCustom(context) {
  var _this = this;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      newListener = _useState2[1];

  useEffect(function () {
    _this.listeners && _this.listeners.push([context, newListener]);
    return function () {
      _this.listeners = _this.listeners ? _this.listeners.filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            listener = _ref4[1];

        return listener !== newListener;
      }) : [];
    };
  }, [newListener, context]);
  return [this.state, this.actions || {}];
}

function associateActions(store, actions) {
  var associatedActions = {};
  forEach(actions, function (value, key) {
    if (typeof value === 'function') {
      associatedActions[key] = value.bind(null, store);
    }
  });
  return associatedActions;
}

function useStore(actions, initialState) {
  if (!actions) {
    throw new Error('You need to set up some actions');
  }

  var store = {
    state: initialState || {},
    listeners: [],
    setState: function setState() {
      return null;
    },
    clearState: function clearState() {
      return null;
    }
  };
  store.setState = setState.bind(store);
  store.clearState = clearState.bind(store);
  store.actions = associateActions(store, actions);
  return useCustom.bind(store);
}
 // TODO: avoid useHook naming patter bc this is not a hook

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var fetchMap = function fetchMap(type) {
  return type === 'list' ? 'fetchingList' : 'fetchingInfo';
};

var sameId = function sameId(id) {
  return function (item) {
    return Boolean(item && String(item === null || item === void 0 ? void 0 : item.id) === String(id));
  };
};

var addToItem = function addToItem(item, id, attrs) {
  return sameId(id)(item) ? _objectSpread$4(_objectSpread$4({}, item), attrs) : item;
};

var replaceItem = function replaceItem(id, newItem) {
  return function (item) {
    return sameId(id)(item) ? newItem : item;
  };
};

var stateMiddleware = function stateMiddleware(store, _ref) {
  var name = _ref.name,
      stateId = _ref.stateId,
      debugActions = _ref.debugActions;

  if (!name) {
    throw new Error('You must provide a name to Croods');
  }

  var piece = findStatePiece(store.state, name, stateId);
  var path = joinWith('@', name, stateId);

  var setState = function setState(newPiece, callback) {
    store.setState(_defineProperty({}, path, newPiece), path);
    callback && callback(store.state);
  };

  var log = function log() {
    var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'INFO';
    var actionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'REQUEST';
    return function (newState) {
      if (!debugActions) return null;
      var colors = {
        REQUEST: 'orange',
        SUCCESS: 'green',
        FAIL: 'red'
      };
      var title = "".concat(operation, " ").concat(actionType, " [").concat(path, "]");
      var state = findStatePiece(newState, name, stateId);
      return consoleGroup(title, colors[actionType])(state, newState);
    };
  };

  return [piece, setState, log];
};

var updateRootState = function updateRootState(store, options, data) {
  var stateId = options.stateId,
      name = options.name,
      updateRoot = options.updateRoot,
      updateRootInfo = options.updateRootInfo,
      updateRootList = options.updateRootList;

  if (name) {
    var shouldChangeRoot = stateId && (updateRoot || updateRootInfo || updateRootList);

    if (shouldChangeRoot) {
      var rootPiece = findStatePiece(store.state, name);

      var state = _objectSpread$4(_objectSpread$4({}, rootPiece), {}, {
        info: updateRoot || updateRootInfo ? data.info : rootPiece.info,
        list: updateRoot || updateRootList ? data.list : rootPiece.list
      });

      store.setState(_defineProperty({}, name, state), name);
    }
  }
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getRequest = function getRequest(store, _ref) {
  var _objectSpread2;

  var _ref$operation = _ref.operation,
      operation = _ref$operation === void 0 ? 'info' : _ref$operation,
      options = _objectWithoutProperties(_ref, ["operation"]);

  var _stateMiddleware = stateMiddleware(store, options),
      _stateMiddleware2 = _slicedToArray(_stateMiddleware, 3),
      piece = _stateMiddleware2[0],
      setState = _stateMiddleware2[1],
      log = _stateMiddleware2[2];

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, fetchMap(operation), true), _defineProperty(_objectSpread2, "".concat(operation, "Error"), null), _objectSpread2));

  setState(newState, log(toUpper(operation)));
  return true;
};

var getSuccess = function getSuccess(store, _ref2, data) {
  var _objectSpread3;

  var _ref2$operation = _ref2.operation,
      operation = _ref2$operation === void 0 ? 'info' : _ref2$operation,
      options = _objectWithoutProperties(_ref2, ["operation"]);

  var _stateMiddleware3 = stateMiddleware(store, options),
      _stateMiddleware4 = _slicedToArray(_stateMiddleware3, 3),
      piece = _stateMiddleware4[0],
      setState = _stateMiddleware4[1],
      log = _stateMiddleware4[2];

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, fetchMap(operation), false), _defineProperty(_objectSpread3, "".concat(operation, "Error"), null), _defineProperty(_objectSpread3, operation, data), _objectSpread3));

  setState(newState, log(toUpper(operation), 'SUCCESS'));
  updateRootState(store, options, _defineProperty({}, operation, data));
  return data;
};

var getFail = function getFail(store, _ref3, error) {
  var _objectSpread4;

  var _ref3$operation = _ref3.operation,
      operation = _ref3$operation === void 0 ? 'info' : _ref3$operation,
      options = _objectWithoutProperties(_ref3, ["operation"]);

  var _stateMiddleware5 = stateMiddleware(store, options),
      _stateMiddleware6 = _slicedToArray(_stateMiddleware5, 3),
      piece = _stateMiddleware6[0],
      setState = _stateMiddleware6[1],
      log = _stateMiddleware6[2];

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, fetchMap(operation), false), _defineProperty(_objectSpread4, "".concat(operation, "Error"), error), _objectSpread4));

  setState(newState, log(toUpper(operation), 'FAIL'));
  return false;
};

var saveRequest = function saveRequest(store, options, id) {
  var _stateMiddleware7 = stateMiddleware(store, options),
      _stateMiddleware8 = _slicedToArray(_stateMiddleware7, 3),
      piece = _stateMiddleware8[0],
      setState = _stateMiddleware8[1],
      log = _stateMiddleware8[2];

  var status = {
    saving: true,
    saveError: null
  };

  var newState = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, piece), status), {}, {
    info: id ? addToItem(piece.info, id, status) : piece.info,
    // TODO: Remove status from data
    list: id ? piece.list.map(function (item) {
      return addToItem(item, id, status);
    }) // TODO: Remove status from data
    : piece.list
  });

  setState(newState, log('SAVE'));
  return true;
};

var saveSuccess = function saveSuccess(store, options, _ref4, addCreatedToTop) {
  var id = _ref4.id,
      data = _ref4.data;

  var _stateMiddleware9 = stateMiddleware(store, options),
      _stateMiddleware10 = _slicedToArray(_stateMiddleware9, 3),
      piece = _stateMiddleware10[0],
      setState = _stateMiddleware10[1],
      log = _stateMiddleware10[2];

  var status = {
    saving: false,
    saveError: null
  };
  var old = id ? find(piece.list, sameId(id)) : data;

  var saved = _objectSpread$3(_objectSpread$3({}, old), data);

  var hasData = saved && !!Object.keys(saved).length;

  if (hasData) {
    var state = _objectSpread$3(_objectSpread$3({}, saved), status);

    var addToList = function addToList(list, item, toTop) {
      return toTop ? [item].concat(_toConsumableArray(list)) : [].concat(_toConsumableArray(list), [item]);
    };

    var _newState = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, piece), status), {}, {
      list: id ? piece.list.map(function (item) {
        return sameId(id)(item) ? state : item;
      }) : addToList(piece.list, state, addCreatedToTop),
      info: sameId(get(piece, 'info.id'))(state) || !piece.info ? state : piece.info
    });

    var _info = _newState.info,
        _list = _newState.list;
    setState(_newState, log('SAVE', 'SUCCESS'));
    updateRootState(store, options, {
      info: _info,
      list: _list
    });
    return saved;
  }

  var newState = _objectSpread$3(_objectSpread$3({}, piece), status);

  var info = piece.info,
      list = piece.list;
  updateRootState(store, options, {
    info: info,
    list: list
  });
  setState(newState, log('SAVE', 'SUCCESS'));
  return null;
};

var saveFail = function saveFail(store, options, _ref5) {
  var error = _ref5.error,
      id = _ref5.id;

  var _stateMiddleware11 = stateMiddleware(store, options),
      _stateMiddleware12 = _slicedToArray(_stateMiddleware11, 3),
      piece = _stateMiddleware12[0],
      setState = _stateMiddleware12[1],
      log = _stateMiddleware12[2];

  var status = {
    saving: false,
    saveError: error
  };

  var newState = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, piece), status), {}, {
    info: id ? addToItem(piece.info, id, status) : piece.info,
    // TODO: Remove status from data
    list: id ? piece.list.map(function (item) {
      return addToItem(item, id, status);
    }) // TODO: Remove status from data
    : piece.list
  });

  setState(newState, log('SAVE', 'FAIL'));
  return false;
};

var destroyRequest = function destroyRequest(store, options, id) {
  var _stateMiddleware13 = stateMiddleware(store, options),
      _stateMiddleware14 = _slicedToArray(_stateMiddleware13, 3),
      piece = _stateMiddleware14[0],
      setState = _stateMiddleware14[1],
      log = _stateMiddleware14[2];

  var status = {
    destroying: true,
    destroyError: null
  };

  var newState = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, piece), status), {}, {
    info: id ? addToItem(piece.info, id, status) : piece.info,
    // TODO: Remove status from data
    list: id ? piece.list.map(function (item) {
      return addToItem(item, id, status);
    }) // TODO: Remove status from data
    : piece.list
  });

  setState(newState, log('DESTROY'));
  return true;
};

var destroySuccess = function destroySuccess(store, options, id) {
  var _stateMiddleware15 = stateMiddleware(store, options),
      _stateMiddleware16 = _slicedToArray(_stateMiddleware15, 3),
      piece = _stateMiddleware16[0],
      setState = _stateMiddleware16[1],
      log = _stateMiddleware16[2];

  var destroyed = find(piece.list, sameId(id));

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, {
    destroying: false,
    list: piece.list.filter(function (item) {
      return !sameId(id)(item);
    }),
    info: sameId(id)(piece === null || piece === void 0 ? void 0 : piece.info) ? null : piece.info
  });

  var info = newState.info,
      list = newState.list;
  setState(newState, log('DESTROY', 'SUCCESS'));
  updateRootState(store, options, {
    info: info,
    list: list
  });
  return destroyed;
};

var destroyFail = function destroyFail(store, options, _ref6) {
  var error = _ref6.error,
      id = _ref6.id;

  var _stateMiddleware17 = stateMiddleware(store, options),
      _stateMiddleware18 = _slicedToArray(_stateMiddleware17, 3),
      piece = _stateMiddleware18[0],
      setState = _stateMiddleware18[1],
      log = _stateMiddleware18[2];

  var status = {
    destroying: false,
    destroyError: error
  };

  var newState = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, piece), status), {}, {
    info: id ? addToItem(piece.info, id, status) : piece.info,
    // TODO: Remove status from data
    list: id ? piece.list.map(function (item) {
      return addToItem(item, id, status);
    }) // TODO: Remove status from data
    : piece.list
  });

  setState(newState, log('DESTROY', 'FAIL'));
  return false;
};

var setInfo = function setInfo(store, options, info, merge) {
  var _stateMiddleware19 = stateMiddleware(store, options),
      _stateMiddleware20 = _slicedToArray(_stateMiddleware19, 3),
      piece = _stateMiddleware20[0],
      setState = _stateMiddleware20[1],
      log = _stateMiddleware20[2];

  var newInfo = merge ? _objectSpread$3(_objectSpread$3({}, piece.info), info) : info;

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, {
    info: newInfo,
    list: info.id ? piece.list.map(replaceItem(info.id, newInfo)) : piece.list
  });

  setState(newState, log('SET', 'INFO'));
  return newState.info;
};

var setList = function setList(store, options, list, merge) {
  var _stateMiddleware21 = stateMiddleware(store, options),
      _stateMiddleware22 = _slicedToArray(_stateMiddleware21, 3),
      piece = _stateMiddleware22[0],
      setState = _stateMiddleware22[1],
      log = _stateMiddleware22[2];

  var newState = _objectSpread$3(_objectSpread$3({}, piece), {}, {
    list: merge ? piece.list.concat(list) : list
  });

  setState(newState, log('SET', 'LIST'));
  return newState.list;
};

var setInfoFromList = function setInfoFromList(store, options) {
  var _stateMiddleware23 = stateMiddleware(store, options),
      _stateMiddleware24 = _slicedToArray(_stateMiddleware23, 1),
      piece = _stateMiddleware24[0];

  var info = find(piece.list, sameId(options === null || options === void 0 ? void 0 : options.id));

  if (info) {
    return setInfo(store, options, info, false);
  }

  return false;
};

var resetState = function resetState(store, options) {
  var _stateMiddleware25 = stateMiddleware(store, options),
      _stateMiddleware26 = _slicedToArray(_stateMiddleware25, 3),
      setState = _stateMiddleware26[1],
      log = _stateMiddleware26[2];

  setState(initialState, log('CLEAR', 'STATE PIECE'));
};

var clearCroodsState = function clearCroodsState(store, options) {
  store.clearState();
  if (options.debugActions) consoleGroup('CLEARED CROODS STATE', 'red')(store.state);
};

var customActions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getRequest: getRequest,
	getSuccess: getSuccess,
	getFail: getFail,
	saveRequest: saveRequest,
	saveSuccess: saveSuccess,
	saveFail: saveFail,
	destroyRequest: destroyRequest,
	destroySuccess: destroySuccess,
	destroyFail: destroyFail,
	setInfo: setInfo,
	setList: setList,
	setInfoFromList: setInfoFromList,
	resetState: resetState,
	clearCroodsState: clearCroodsState
});

var useGlobal = useStore(customActions, {});

var CroodsContext = /*#__PURE__*/createContext({});

var CroodsProvider = function CroodsProvider(_ref) {
  var children = _ref.children,
      options = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(CroodsContext.Provider, {
    value: options
  }, children);
};

var useBaseOptions = function useBaseOptions() {
  return useContext(CroodsContext);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useCroods = function useCroods(_ref) {
  var name = _ref.name,
      stateId = _ref.stateId,
      fetchOnMount = _ref.fetchOnMount,
      opts = _objectWithoutProperties(_ref, ["name", "stateId", "fetchOnMount"]);

  if (typeof name !== 'string' || name.length < 1) {
    throw new Error('You must pass a name property to useCroods/Fetch');
  } // baseOptions -> config from provider


  var baseOptions = useBaseOptions();
  var contextPath = getStateKey(name, stateId);

  var _useGlobal = useGlobal(contextPath),
      _useGlobal2 = _slicedToArray(_useGlobal, 2),
      state = _useGlobal2[0],
      actions = _useGlobal2[1];

  var piece = findStatePiece(state, name, stateId, fetchOnMount, opts.id);

  var options = _objectSpread$2(_objectSpread$2(_objectSpread$2({}, baseOptions), opts), {}, {
    name: name,
    stateId: stateId
  });

  var fetch = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2$requestConfig = _ref2.requestConfig,
        requestConfig = _ref2$requestConfig === void 0 ? {} : _ref2$requestConfig,
        contextOpts = _objectWithoutProperties(_ref2, ["requestConfig"]);

    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var query,
          config,
          id,
          debugRequests,
          inheritedQuery,
          queryString,
          api,
          operation,
          path,
          url,
          method,
          _args3 = arguments;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              config = _objectSpread$2(_objectSpread$2({}, options), contextOpts);
              id = config.id, debugRequests = config.debugRequests, inheritedQuery = config.query;
              queryString = buildQueryString(query || inheritedQuery, config);
              _context3.next = 6;
              return buildApi(config);

            case 6:
              api = _context3.sent;
              operation = config.operation || (id ? 'info' : 'list');
              path = buildUrl(config)(id);

              if (!shouldUseCache(config)(id, piece, actions.setInfoFromList)) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", true);

            case 11:
              url = joinWith('?', path, queryString);
              method = 'GET';
              debugRequests && requestLogger(url, method);
              actions.getRequest(_objectSpread$2(_objectSpread$2({}, config), {}, {
                operation: operation
              }));
              return _context3.abrupt("return", api(_objectSpread$2(_objectSpread$2({}, requestConfig), {}, {
                method: method,
                url: url
              })).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(response) {
                  var parsers, result;
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          parsers = ['Info', 'List', 'Fetch'];
                          _context.next = 3;
                          return doSuccess(path, method, config, id)(response, parsers);

                        case 3:
                          result = _context.sent;
                          return _context.abrupt("return", actions.getSuccess(_objectSpread$2(_objectSpread$2({}, config), {}, {
                            operation: operation
                          }), result));

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }())["catch"]( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(error) {
                  var errorMessage;
                  return regenerator.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return doFail(path, method, config)(error);

                        case 2:
                          errorMessage = _context2.sent;
                          return _context2.abrupt("return", actions.getFail(_objectSpread$2(_objectSpread$2({}, config), {}, {
                            operation: operation
                          }), errorMessage));

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  }, [actions, options, piece]);
  var save = useCallback(function () {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onUploadProgress = _ref6.onProgress,
        _ref6$requestConfig = _ref6.requestConfig,
        requestConfig = _ref6$requestConfig === void 0 ? {} : _ref6$requestConfig,
        addToTop = _ref6.addToTop,
        contextOpts = _objectWithoutProperties(_ref6, ["onProgress", "requestConfig", "addToTop"]);

    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(rawBody) {
        var config, id, givenMethod, parseParams, paramsParser, debugRequests, paramsParserFn, api, url, method, data;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                config = _objectSpread$2(_objectSpread$2({}, options), contextOpts);
                id = config.id, givenMethod = config.method;
                parseParams = config.parseParams, paramsParser = config.paramsParser, debugRequests = config.debugRequests;
                paramsParserFn = createHumps(parseParams || paramsParser || snakeCase);
                _context6.next = 6;
                return buildApi(config);

              case 6:
                api = _context6.sent;
                url = buildUrl(config)(id);
                method = givenMethod || (id ? 'PUT' : 'POST');
                data = paramsParserFn(omit(rawBody, 'id'));
                debugRequests && requestLogger(url, method, data);
                actions.saveRequest(config, id);
                return _context6.abrupt("return", api(_objectSpread$2(_objectSpread$2({}, requestConfig), {}, {
                  onUploadProgress: onUploadProgress,
                  url: url,
                  method: method,
                  data: data
                })).then( /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(response) {
                    var parsers, result;
                    return regenerator.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            parsers = ['Update', 'Create', 'Save'];
                            _context4.next = 3;
                            return doSuccess(url, method, config, id)(response, parsers);

                          case 3:
                            result = _context4.sent;
                            return _context4.abrupt("return", actions.saveSuccess(config, {
                              id: id,
                              data: result
                            }, addToTop));

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x4) {
                    return _ref8.apply(this, arguments);
                  };
                }())["catch"]( /*#__PURE__*/function () {
                  var _ref9 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(error) {
                    var errorMessage;
                    return regenerator.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return doFail(url, method, config)(error);

                          case 2:
                            errorMessage = _context5.sent;
                            return _context5.abrupt("return", actions.saveFail(config, {
                              error: errorMessage,
                              id: id
                            }));

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x5) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }();
  }, [actions, options]);
  var destroy = useCallback(function () {
    var contextOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(query) {
        var requestConfig,
            config,
            id,
            debugRequests,
            inheritedQuery,
            queryString,
            api,
            path,
            url,
            method,
            _args9 = arguments;
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                requestConfig = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                config = _objectSpread$2(_objectSpread$2({}, options), contextOpts);
                id = config.id, debugRequests = config.debugRequests, inheritedQuery = config.query;
                queryString = buildQueryString(query || inheritedQuery, config);
                _context9.next = 6;
                return buildApi(config);

              case 6:
                api = _context9.sent;
                path = buildUrl(config)(id);
                url = joinWith('?', path, queryString);
                method = 'DELETE';
                debugRequests && requestLogger(url, method);
                actions.destroyRequest(config, id);
                return _context9.abrupt("return", api(_objectSpread$2(_objectSpread$2({}, requestConfig), {}, {
                  method: method,
                  url: url
                })).then( /*#__PURE__*/function () {
                  var _ref11 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(response) {
                    return regenerator.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return doSuccess(url, method, config)(response);

                          case 2:
                            return _context7.abrupt("return", actions.destroySuccess(config, id));

                          case 3:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x7) {
                    return _ref11.apply(this, arguments);
                  };
                }())["catch"]( /*#__PURE__*/function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(error) {
                    var errorMessage;
                    return regenerator.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return doFail(url, method, config)(error);

                          case 2:
                            errorMessage = _context8.sent;
                            return _context8.abrupt("return", actions.destroyFail(config, {
                              error: errorMessage,
                              id: id
                            }));

                          case 4:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function (_x8) {
                    return _ref12.apply(this, arguments);
                  };
                }()));

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x6) {
        return _ref10.apply(this, arguments);
      };
    }();
  }, [actions, options]);
  var setInfo = useCallback(function (info, merge) {
    actions.setInfo(options, info, merge);
  }, [actions, options]);
  var setList = useCallback(function (list, merge) {
    actions.setList(options, list, merge);
  }, [actions, options]);
  var resetState = useCallback(function () {
    actions.resetState(options);
  }, [actions, options]);
  var dangerouslyClearCroodsState = useCallback(function () {
    actions.clearCroodsState(options);
  }, [actions, options]);
  useEffect(function () {
    fetchOnMount && fetch({
      id: options.id
    })(options.query);
  }, [options.id, options.query, fetchOnMount]);
  return [piece, {
    fetch: fetch,
    save: save,
    destroy: destroy,
    setInfo: setInfo,
    setList: setList,
    resetState: resetState,
    dangerouslyClearCroodsState: dangerouslyClearCroodsState
  }];
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Fetch(_ref) {
  var _state$list;

  var id = _ref.id,
      query = _ref.query,
      path = _ref.path,
      stateId = _ref.stateId,
      render = _ref.render,
      opts = _objectWithoutProperties(_ref, ["id", "query", "path", "stateId", "render"]);

  var baseOptions = useBaseOptions();

  var options = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, baseOptions), opts), {}, {
    id: id,
    path: path,
    stateId: stateId
  });

  var _useCroods = useCroods(options),
      _useCroods2 = _slicedToArray(_useCroods, 2),
      state = _useCroods2[0],
      actions = _useCroods2[1];

  var error = state.listError || state.infoError;
  var isList = !id;
  var result = isList ? state.list : state.info;
  useEffect(function () {
    actions.fetch({
      id: id
    })(query);
  }, [id, query, path, stateId]);

  if (isList ? state.fetchingList : state.fetchingInfo) {
    var _options$renderLoadin;

    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_options$renderLoadin = options.renderLoading) === null || _options$renderLoadin === void 0 ? void 0 : _options$renderLoadin.call(options)) || /*#__PURE__*/React.createElement("div", null, "Loading..."));
  }

  if (error) {
    var _options$renderError;

    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_options$renderError = options.renderError) === null || _options$renderError === void 0 ? void 0 : _options$renderError.call(options, error)) || /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'red'
      }
    }, error));
  }

  if (!isList && !state.info) {
    var _options$renderEmpty;

    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_options$renderEmpty = options.renderEmpty) === null || _options$renderEmpty === void 0 ? void 0 : _options$renderEmpty.call(options)) || null);
  }

  if (isList && !Boolean((_state$list = state.list) === null || _state$list === void 0 ? void 0 : _state$list.length) && options.renderEmpty) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, options.renderEmpty() || null);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, render(result, [state, actions]));
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useHydrate = function useHydrate(_ref, config) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'list' : _ref$type,
      name = _ref.name,
      stateId = _ref.stateId,
      value = _ref.value;

  if (typeof name !== 'string' || name.length < 1) {
    throw new Error('You must pass a name property to useHydrate');
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hydrated = _useState2[0],
      setHydrated = _useState2[1];

  var baseOptions = useBaseOptions();

  var options = _objectSpread(_objectSpread({
    name: name
  }, baseOptions), config);

  var contextPath = getStateKey(name, stateId);

  var _useGlobal = useGlobal(contextPath),
      _useGlobal2 = _slicedToArray(_useGlobal, 2),
      state = _useGlobal2[0],
      _useGlobal2$ = _useGlobal2[1],
      setInfo = _useGlobal2$.setInfo,
      setList = _useGlobal2$.setList;

  useEffect(function () {
    if (type === 'list') {
      setList({
        name: contextPath
      }, value);
    }

    if (type === 'info') {
      setInfo({
        name: contextPath
      }, value);
    }

    setHydrated(true);
  }, []);
  useEffect(function () {
    if (hydrated && options.debugActions) {
      var statePiece = findStatePiece(state, name, stateId);
      var title = "".concat(toUpper(type), " HYDRATE [").concat(contextPath, "]");
      consoleGroup(title, 'cornflowerblue')(statePiece, state);
    }
  }, [hydrated, options.debugActions]);
};

export { CroodsContext, CroodsProvider, Fetch, useBaseOptions, useCroods, useHydrate, useStore };
